import { call } from 'redux-saga/effects'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'

interface AgentApis {
    CREATE_SESSION: string
    CHAT: (sessionId: string) => string
    LIST_SESSIONS: string
    GET_SESSION_MESSAGES: (sessionId: string) => string
    DELETE_SESSION: (sessionId: string) => string
    SUBMIT_FEEDBACK: string
}

export function createAgentSaga(apis: AgentApis, agentLabel: string) {
    function* createSession<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const data = action.payload
            const resp = yield call(CallApi.POST, apis.CREATE_SESSION, data, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || `Failed to create ${agentLabel} session`, status_code: 400, success: false })
        }
    }

    function* chat<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const { session_id, ...data } = action.payload as { session_id: string; [key: string]: any }
            const resp = yield call(CallApi.POST, apis.CHAT(session_id), data, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || `Failed to chat with ${agentLabel}`, status_code: 400, success: false })
        }
    }

    function* listSessions<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const resp = yield call(CallApi.GET, apis.LIST_SESSIONS, action.payload, false, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || `Failed to list ${agentLabel} sessions`, status_code: 400, success: false })
        }
    }

    function* getSessionMessages<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const { session_id } = action.payload as { session_id: string }
            const resp = yield call(CallApi.GET, apis.GET_SESSION_MESSAGES(session_id), {}, false, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || `Failed to get ${agentLabel} session messages`, status_code: 400, success: false })
        }
    }

    function* deleteSession<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const { session_id } = action.payload as { session_id: string }
            const resp = yield call(CallApi.DELETE, apis.DELETE_SESSION(session_id), {}, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || `Failed to delete ${agentLabel} session`, status_code: 400, success: false })
        }
    }

    function* submitFeedback<P, R>(action: { type: string; payload: P; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
        try {
            const data = action.payload
            const resp = yield call(CallApi.POST, apis.SUBMIT_FEEDBACK, data, true)
            if (resp.status >= 200 && resp.status < 300 && resp.data) {
                action?.onSuccess(resp.data as SuccessResponse<R>)
            } else {
                action?.onError(resp.data as ErrorResponse<R>)
            }
        } catch (e: any) {
            action?.onError({ message: e?.message || 'Failed to submit feedback', status_code: 400, success: false })
        }
    }

    return { createSession, chat, listSessions, getSessionMessages, deleteSession, submitFeedback }
}
